import React from 'react'

const Campus = props => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path
      fill={props.fill || '#1A344F'}
      fillRule="nonzero"
      d="M12.002 2c.1 0 .2.018.295.056l.102.055.122.067 4.166 3.334.032.039.102.12.092.137.043.138.034.173.01.044v3.334h4.167c.458 0 .833.375.833.834v10.835a.836.836 0 01-.833.834H2.833A.836.836 0 012 21.166V10.331c0-.459.375-.834.833-.834H7V6.163l.008-.042.038-.179.04-.133.094-.138.1-.12.032-.039 4.167-3.334.125-.069.097-.052a.82.82 0 01.3-.057zM12 3.897L8.667 6.563v3.768a.836.836 0 01-.834.833H3.667v9.169H9.5v-2.5a2.5 2.5 0 115-.001v2.501h5.833v-9.169h-4.166a.836.836 0 01-.834-.833V6.564L12 3.897zM12 17a.834.834 0 00-.833.833v2.501h1.666v-2.5A.835.835 0 0012 17zm-5-4.168v1.667H5.334v-1.667H7zm3.334 0v1.667H8.667v-1.667h1.667zm5 0v1.667h-1.667v-1.667h1.667zm3.333 0v1.667H17v-1.667h1.667zM12 6.163a1.668 1.668 0 11-.002 3.336A1.668 1.668 0 0112 6.163z"
    />
  </svg>
)

export default Campus
